import React from 'react'
import ContentTemplate from '../../components/common/ContentTemplate'
import SubContentTemplate from '../../components/common/SubContentTemplate'
import PageHeaderContainer from '../../containers/common/PageHeaderContainer'
import PageTitleTemplate from '../../components/common/PageTitleTemplate'
import BreadcrumbContainer from '../../containers/common/BreadcrumbContainer'
import PageTemplate from '../../components/common/PageTemplate'
import { WIZPARK_STORE } from '../../constants/page'
import WizparkStore from '../../components/wizpark/WizparkStore'

const WizparkStorePage = () => {
  return (
    <PageTemplate className="park">
      <PageHeaderContainer title="kt wiz는?" subtitle="한국 프로야구의 ‘10번째 심장’ kt wiz를 소개합니다!" image={require('../../assets/img/ktwiz/sub_tit_ktwiz.png')} />
      <ContentTemplate>
        <PageTitleTemplate>
          <BreadcrumbContainer page={WIZPARK_STORE} />
        </PageTitleTemplate>
        <SubContentTemplate className="park iksan">
          <WizparkStore />
        </SubContentTemplate>
      </ContentTemplate>
    </PageTemplate>
  )
}

export default WizparkStorePage
